import { render, staticRenderFns } from "./AS_DutiesOfConsumer.vue?vue&type=template&id=75d23eb8&scoped=true&"
import script from "./AS_DutiesOfConsumer.vue?vue&type=script&lang=js&"
export * from "./AS_DutiesOfConsumer.vue?vue&type=script&lang=js&"
import style0 from "./AS_DutiesOfConsumer.vue?vue&type=style&index=0&id=75d23eb8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75d23eb8",
  null
  
)

export default component.exports